module.exports = __webpack_public_path__ + "static/media/switch-off.b6d54747.svg";